<script setup>
const props = defineProps({
  buy: {
    type: Boolean,
    default: false,
  },
  sell: {
    type: Boolean,
    default: false,
  },
  active: {
    type: Boolean,
    default: false,
  },
})

const onlyBuy = computed(() => props.buy && !props.sell)
const onlySell = computed(() => props.sell && !props.buy)
</script>

<template>
  <div
    class="w-[13px] h-[13px] rounded border border-border cursor-pointer inline-flex items-center justify-center" :class="{
      '!border-textPrimary': active,
    }"
  >
    <svg width="9.6" height="9.6" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect v-if="buy" x="0.199219" y="0.949219" width="4.51765" :height="onlyBuy ? 9.6 : 4.51765" rx="1.12941" fill="#01BC8D" />
      <rect v-if="sell" x="0.199219" :y="onlySell ? 0.949219 : 6.03125" width="4.51765" :height="onlySell ? 9.6 : 4.51765" rx="1.12941" fill="#F1493F" />
      <rect x="5.28149" y="0.949219" width="4.51765" height="9.6" rx="1.12941" fill="#E5E7EB" />
    </svg>
  </div>
</template>
